import { render } from "./BottomTools.vue?vue&type=template&id=0c36c675&scoped=true"
import script from "./BottomTools.vue?vue&type=script&lang=js"
export * from "./BottomTools.vue?vue&type=script&lang=js"

import "./BottomTools.vue?vue&type=style&index=0&id=0c36c675&scoped=true&lang=css"

import exportComponent from "/Users/iyongmin/Documents/twin-cosmos/jeju43-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c36c675"]])

export default __exports__